<template>
  <crud-form
    v-model="payload"
    page-title="Vincular produto ao template"
    :total-group="1"
    :request-class="requestClass"
    :navigate-back-params="{ templateId: getTemplateId }"
    :override-create-payload="overrideBeforeCreate"
    :override-edit-payload="overrideEditPayload"
    remove-buttons
    navigate-back-route="produtoTemplate.list"
    navigate-page-after-save="produtoTemplate.list"
  >
    <template slot="group-1">
      <form-group>
        <v-tabs v-model="tabs">
          <v-tab>
            Produto template
          </v-tab>
          <v-tab>
            Informações do produto
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <form-group>
              <v-row class="mt-6">
                <v-col cols="4">
                  <v-row>
                    <v-col cols="12">
                      <input-select
                        id="input:idProdutoServico"
                        v-model="payload.idProdutoServico"
                        label="Produto"
                        :loading="produtoLoading"
                        :items="produtoOptions"
                        :disabled="isEdit"
                        outlined
                        required
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row>
                    <v-col :cols="setCols">
                      <input-select
                        id="input:idFornecedor"
                        v-model="payload.idFornecedor"
                        label="Fornecedor"
                        :loading="fornecedorLoading"
                        :items="fornecedorOptions"
                        :disabled="isEdit || fornecedorOptions.length <= 0"
                        outlined
                        required
                      />
                    </v-col>
                    <v-col
                      v-if="!isEdit"
                      cols="2"
                    >
                      <create-fornecedor-template />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row>
                    <v-col :cols="setCols">
                      <input-select
                        id="input:idIntegrador"
                        v-model="payload.idIntegrador"
                        label="Integrador"
                        :loading="integradorLoading"
                        :items="integradorOptions"
                        :disabled="isEdit || integradorOptions.length <= 0"
                        outlined
                        required
                      />
                    </v-col>
                    <v-col
                      v-if="!isEdit"
                      cols="2"
                    >
                      <create-integrador-template
                        @success="successIntegrador($event)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <product-template-content-values :value="payload" />
              <div
                class="pa-4 d-flex justify-end align-center"
              >
                <div>
                  <v-btn
                    color="#6A6E7B"
                    outlined
                    @click="navigateBack()"
                  >
                    CANCELAR
                  </v-btn>
                </div>
                <div
                  class="ml-2"
                >
                  <v-btn
                    class="white--text"
                    type="submit"
                    color="#2ABD49"
                    :loading="loading"
                  >
                    SALVAR
                  </v-btn>
                </div>
              </div>
            </form-group>
          </v-tab-item>
          <v-tab-item>
            <edit-product-content-body
              v-model="produtoPayload"
            />
            <div
              class="pa-4 d-flex justify-end align-center"
            >
              <div>
                <v-btn
                  color="#6A6E7B"
                  outlined
                  @click="navigateBack()"
                >
                  CANCELAR
                </v-btn>
              </div>
              <div
                class="ml-2"
              >
                <v-btn
                  class="white--text"
                  color="#2ABD49"
                  :loading="loading"
                  @click="onEditExtraClass()"
                >
                  SALVAR
                </v-btn>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import LocalSessionMixin from '@/app/arch/mixins/LocalSessionMixin';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import IntegradorRequest from 'Modules/contacard/produto/integrador/IntegradorRequest';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import FornecedorRequest from 'Modules/contacard/produto/fornecedor/FornecedorRequest';
import ProdutoRequestMixin from 'Modules/contacard/produto/product/ProdutoRequestMixin';
import ProdutoTemplateRequest from 'Modules/contacard/produto/templates/produto/ProdutoTemplateRequest';
import RequestSelectMixin from '@/app/arch/mixins/RequestSelectMixin';
import RouterMixin from '@/app/arch/mixins/RouterMixin';
import CreateFornecedorTemplate from './components/CreateFornecedorTemplate.vue';
import CreateIntegradorTemplate from './components/CreateIntegradorTemplate.vue';
import EditProductContentBody from '../../product/components/form/EditProductContentBody.vue';
import ProductTemplateContentValues, { itemListaValor } from './components/ProductTemplateContentValues.vue';

export default {
  name: 'TemplateProdutoForm',
  components: {
    CrudForm,
    FormGroup,
    CreateFornecedorTemplate,
    CreateIntegradorTemplate,
    EditProductContentBody,
    ProductTemplateContentValues,
  },
  mixins: [LocalSessionMixin,
    RulesMixin, ServiceMixin, ProdutoRequestMixin,
    RequestSelectMixin, RouterMixin],
  data: () => ({
    requestClass: ProdutoTemplateRequest,
    requestIntegrador: IntegradorRequest,
    requestFornecedor: FornecedorRequest,
    fornecedorLoading: false,
    integradorLoading: false,
    produtoLoading: false,
    tabs: null,
    idProdutoServicoIntegrador: '',
    idProdutoServicoFornecedor: '',
    payload: {
      idTemplate: '',
      idFornecedor: '',
      idIntegrador: '',
      idProdutoServico: '',
      indSomarTaxasBonus: '',
      valores: {
        cartaoDebito: [{ ...itemListaValor }],
        cartaoCredito: [{ ...itemListaValor }],
        cartaoCreditoParcelado: [{ ...itemListaValor }],
        pix: [{ ...itemListaValor }],
        prePago: [{ ...itemListaValor }],
        posPago: [{ ...itemListaValor }],
      },
    },
    fornecedorOptions: [],
    integradorOptions: [],
    produtoOptions: [],
  }),
  computed: {
    setCols() {
      return this.isEdit ? '12' : '10';
    },
    getTemplateId() {
      return this.getSessionItem('templateId');
    },

    produtoPayload() {
      if (this.produtoOptions.length >= 1) {
        const produto = this.getProductById;

        if (produto && produto.item) {
          return produto.item;
        }
        return {};
      }
      return {};
    },
    getProductById() {
      return this.produtoOptions.find(
        (item) => item.value === this.payload.idProdutoServico,
      );
    },
    getProductCategory() {
      const produto = this.produtoPayload;
      return produto ? produto.produtoServicoCategoria : null;
    },
    getProdutoRequest() {
      return this.getProdutoRequestByCategory(
        this.getProductCategory,
      );
    },
    loading: {
      get() {
        return this.produtoLoading;
      },
      set(bool) {
        this.produtoLoading = bool;
      },
    },
    produtoServicoIntegrador() {
      const integradorProduto = this.getSessionItem('produtoServicoIntegrador');
      return integradorProduto ? integradorProduto.id : null;
    },
    isEdit() {
      const { id } = this.$route.params;
      return id && Number(id) >= 0;
    },
    getIdProdutoIntegrador() {
      const integrador = this.integradorOptions.find(
        (item) => item.value === this.payload.idIntegrador,
      );
      if (integrador && integrador.item) {
        return integrador.item.id;
      }
      return null;
    },
    getIdProdutoFornecedor() {
      return this.payload.idFornecedor;
    },
    idProduto() {
      return this.payload.idProdutoServico;
    },
  },
  watch: {
    'payload.idProdutoServico': {
      immediate: true,
      handler(id) {
        if (id) {
          if (this.isEdit) {
            this.setProductName();
          } else {
            this.getFornecedorOptions();
            this.getIntegradorOptions();
          }
        }
      },
    },
    'payload.idFornecedor': {
      immediate: true,
      handler(id) {
        if (id) {
          if (this.isEdit) {
            this.getFornecedor();
          } else {
            this.getProdutoFornecedor();
          }
        }
      },
    },
    'payload.idIntegrador': {
      immediate: true,
      handler(id) {
        if (id) {
          if (this.isEdit) {
            this.getIntegrador();
          }
        }
      },
    },
  },
  created() {
    if (!this.isEdit) {
      this.getProductOptions();
    }
  },
  methods: {
    navigateBack() {
      this.navigateTo(
        'produtoTemplate.list',
        { templateId: this.getTemplateId },
      );
    },
    overrideBeforeCreate() {
      return {
        ...this.payload,
        valores: this.formatValues(),
        idProdutoServicoIntegrador: this.getIdProdutoIntegrador,
        idProdutoServicoFornecedor: this.idProdutoServicoFornecedor,
        idTemplate: this.getTemplateId,
      };
    },
    overrideEditPayload() {
      return {
        ...this.payload,
        valores: this.formatValues(),
        idProdutoServicoIntegrador: this.produtoServicoIntegrador,
      };
    },
    formatValues() {
      const { valores } = this.payload;
      return Object.keys(valores)
        .map(
          (key) => ({
            [key]: valores[key]
              .filter(this.filterEmptyValues)
              .map(
                (item) => ({
                  ...item,
                  valor: Number(
                    String(item.valor).replace(',', '.'),
                  ),
                }),
              ),
          }),
        ).reduce(
          (obj, item) => ({
            ...obj,
            ...item,
          }),
          {},
        );
    },
    filterEmptyValues(item) {
      return item.tipoComissaoTemplate !== '' && item.tipoValorTemplate !== '';
    },
    onEditExtraClass() {
      const produto = this.produtoPayload;
      const request = this.getProdutoRequest;

      if (produto && produto.id) {
        this.handleProductLoading();
        this.callService(
          request.edit(
            produto.id,
            produto,
          ),
          this.handleProductLoading,
        );
      }
    },
    getProdutoFornecedor() {
      this.callService(
        this.requestFornecedor.listProdutoFornecedor(
          this.makeParams({
            idFornecedor: this.payload.idFornecedor,
            idProdutoServico: this.payload.idProdutoServico,
          }),
        ),
        this.setFornecedorProdutoId,
        {
          errorMessage: 'Falha ao buscar produto-fornecedor',
          showSuccessSwal: false,
        },
      );
    },
    setFornecedorProdutoId(response) {
      if (this.hasData(response)) {
        const { data } = response.data;
        if (Array.isArray(data) && data.length >= 1) {
          this.idProdutoServicoFornecedor = data[0].id;
        }
      }
    },
    getFornecedorOptions() {
      this.handleFornecedorLoading();
      this.serviceCall(
        this.requestProduto.listFornecedores(
          this.payload.idProdutoServico,
          this.makeParams(),
        ),
        this.setDataOptions(
          'fornecedorOptions',
          'fornecedor',
          'nomFornecedor',
        ),
        'Falha ao buscar listagem de fornecedores!',
        'fornecedor.id',
        this.handleFornecedorLoading,
      );
    },
    getIntegradorOptions() {
      this.handleIntegradorOptions();
      this.serviceCall(
        this.requestIntegrador.listIntegradorProduto(
          this.makeIntegradorParams(),
        ),
        this.setDataOptions(
          'integradorOptions',
          'integrador',
          'nomIntegrador',
        ),
        'Falha ao buscar listagem de integradores!',
        'integrador.id',
        this.handleIntegradorOptions,
      );
    },
    makeIntegradorParams() {
      return this.makeParams({
        idProdutoServico: this.payload.idProdutoServico,
      });
    },
    getProductOptions() {
      this.handleProductLoading();
      this.serviceCall(
        this.requestProduto.list(
          this.makeParams(),
        ),
        this.setDataOptions(
          'produtoOptions',
          'nomProdutoServico',
        ),
        'Falha ao buscar listagem de produtos!',
        this.handleProductLoading,
      );
    },
    setProductName() {
      this.handleProductLoading();
      this.callService(
        this.requestProduto.get(
          this.payload.idProdutoServico,
        ),
        this.hanldeProductName,
        this.makeSwalConfig(
          'Falha ao buscar nome do produto',
        ),
      );
    },
    handleProductLoading() {
      this.produtoLoading = !this.produtoLoading;
    },
    hanldeProductName(response) {
      if (this.hasData(response)) {
        const { produtoServicoCategoria } = response.data;
        if (this.hasNotProductRequest(produtoServicoCategoria)) {
          this.getProductByCategory(
            produtoServicoCategoria,
          );
        } else {
          this.setEditDataOptions({
            response,
            dataOption: 'produtoOptions',
            dataProperty: 'nomProdutoServico',
            id: this.idProduto,
          });
        }
      } else {
        this.handleProductLoading();
      }
    },
    getProductByCategory(category) {
      this.callService(
        this.getProdutoRequestByCategory(
          category,
        ).get(this.payload.idProdutoServico),
        this.setProductInfo,
        this.makeSwalConfig(
          'Falha ao buscar informações do produto',
        ),
      );
    },
    setProductInfo(response) {
      this.handleProductLoading();
      if (this.hasData(response)) {
        this.setEditDataOptions({
          response,
          dataOption: 'produtoOptions',
          dataProperty: 'nomProdutoServico',
          id: this.idProduto,
        });
      }
    },
    setEditDataOptions({
      response,
      dataOption,
      dataProperty,
      id,
    }) {
      if (this.hasData(response)) {
        this[dataOption] = this.makeDataOptions(response.data, dataProperty);
      } else {
        this[dataOption] = this.makeDataOptions(
          { id },
          'id',
        );
      }
    },
    makeDataOptions(item, prop) {
      return [
        {
          value: item.id,
          text: item[prop],
          item,
        },
      ];
    },
    makeSwalConfig(message) {
      return {
        showSuccessSwal: false,
        errorMessage: message,
      };
    },
    getFornecedor() {
      this.handleFornecedorLoading();
      this.callService(
        this.requestFornecedor.get(
          this.payload.idFornecedor,
        ),
        this.handleFornecedorName,
        this.makeSwalConfig(
          'Falha ao buscar nome do fornecedor',
        ),
      );
    },
    handleFornecedorLoading() {
      this.fornecedorLoading = !this.fornecedorLoading;
    },
    handleFornecedorName(response) {
      this.handleFornecedorLoading();
      this.setEditDataOptions({
        response,
        dataOption: 'fornecedorOptions',
        dataProperty: 'nomFornecedor',
        id: this.payload.idFornecedor,
      });
    },
    getIntegrador() {
      this.handleIntegradorOptions();
      this.callService(
        this.requestIntegrador.get(
          this.payload.idIntegrador,
        ),
        this.handleIntegradorName,
        this.makeSwalConfig(
          'Falha ao buscar nome do integrador',
        ),
      );
    },
    handleIntegradorOptions() {
      this.integradorLoading = !this.integradorLoading;
    },
    handleIntegradorName(response) {
      this.handleIntegradorOptions();
      this.setEditDataOptions({
        response,
        dataOption: 'integradorOptions',
        dataProperty: 'nomIntegrador',
        id: this.payload.idIntegrador,
      });
    },

    successIntegrador(response) {
      if (this.hasData(response)) {
        this.getIntegradorOptions();
      }
    },

  },
  reactiveProvide: {
    name: 'template',
    include: ['idProduto', 'integradorOptions', 'fornecedorOptions'],
  },
  provide() {
    return {
      setDataLoading: () => {
        this.loading = !this.loading;
      },
    };
  },
};
</script>
